namespace $ {

	export class $shm_pb extends $shm_pocketbase_client {

		static override storage_prefix() {
			return 'hitalama_ba'
		}

		static override url_store_key() {
			return 'hitalama_ba_pb_url'
		}

		static url_arg() {
			return this.$.$mol_state_arg.value( 'pb_url' ) || ''
		}

		static override admin_auth_store_key( key: string ) {
			const url = this.url_arg().replace( /\/+$/, '' )
			return url
				? `${ this.storage_prefix() }_admin_auth:${ encodeURIComponent( url ) }:${ key }`
				: super.admin_auth_store_key( key )
		}

		static default_url_for( location: { host: string, hostname: string, protocol: string } ) {
			const host = location.host
			const prerelease = '.158-160-195-195.ip.hyoo.ru'

			if( location.hostname.endsWith( prerelease ) ) {
				return `${ location.protocol }//pb${ prerelease }`
			}

			if( host.startsWith( 'dashboard.' ) ) {
				return `${ location.protocol }//pb.${ host.slice( 10 ) }`
			}

			if( host.startsWith( 'ba.' ) ) {
				return `${ location.protocol }//pb.${ host.slice( 3 ) }`
			}

			return 'https://pb.shmakov.media'
		}

		static override default_url() {
			return this.default_url_for( $mol_dom_context.location )
		}

		static override url() {
			const url = ( this.url_arg() || super.url() ).replace( /\/+$/, '' )
			const host = $mol_dom_context.location.hostname
			if( ( host === 'localhost' || host === '127.0.0.1' ) && url === 'http://127.0.0.1:8090' ) {
				return 'http://127.0.0.1:8092'
			}
			return url
		}

		static override realtime_url() {
			const url = super.url()
			const host = $mol_dom_context.location.hostname
			if( ( host === 'localhost' || host === '127.0.0.1' ) && url === 'http://127.0.0.1:8090' ) {
				return 'http://127.0.0.1:8090'
			}
			return this.url()
		}

	}

}
